import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useQuery, useMutation } from "convex/react";
import { api } from "./convex/_generated/api";

import "./ActivityPage.css";

export default function ActivityPage() {
  const { suggestionId, userId } = useParams();
  const navigate = useNavigate();

  const [actualMinutes, setActualMinutes] = useState("");
  const [selfRating, setSelfRating] = useState(0);
  const [notes, setNotes] = useState("");

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [result, setResult] = useState(null);

 

  const suggestion = useQuery(
    api.progress.getById,
    suggestionId && userId
      ? {
          suggestionId,
          userId,
        }
      : "skip"
  );

  const completeActivity = useMutation(
    api.progress.completeActivity
  );

  const handleSubmit = async (e) => {
    e.preventDefault();

    setError("");

    //if (!suggestion) {
      //setError("Activity could not be found.");
      //return;
    //}

    //if (!actualMinutes || Number(actualMinutes) < 0) {
      //setError("Please enter the number of minutes you completed.");
      //return;
    //}

    //if (selfRating < 1 || selfRating > 10) {
      //setError("Self rating must be between 1 and 10.");
      //return;
    //}

    try {
      setLoading(true);

      const response = await completeActivity({
        userId,
        suggestionId,

        actualMinutes: Number(actualMinutes),

        selfRating: Number(selfRating),

        completed: true,

        notes: notes.trim() || undefined,
      });

      console.log("Activity completed:", response);

      setResult(response);
    } catch (error) {
      console.error("Error completing activity:", error);

      setError(
        error?.message ||
          "Failed to complete activity."
      );
    } finally {
      setLoading(false);
    }
  };

  // -----------------------------------------
  // Missing route params
  // -----------------------------------------

  if (!suggestionId || !userId) {
    return (
      <div className="activity-page">
        <div className="activity-container activity-container--narrow">
          <div className="activity-message-card">
            <p className="activity-eyebrow">
              Progress Activity
            </p>

            <h1 className="activity-message-title">
              Activity Not Found
            </h1>

            <p className="activity-message-text">
              The activity information is missing.
            </p>

            <button
              onClick={() => navigate(-1)}
              className="activity-button activity-button--secondary"
            >
              Go Back
            </button>
          </div>
        </div>
      </div>
    );
  }

  // -----------------------------------------
  // Loading
  // -----------------------------------------

  //if (suggestion === undefined) {
   // return (
     // <div className="min-h-screen bg-slate-950 p-8 text-white">
       // <div className="mx-auto max-w-2xl">
        //  <p className="text-slate-400">
          //  Loading activity...
         // </p>
        //</div>
      //</div>
    //);
  //}

  // -----------------------------------------
  // Suggestion not found
  // -----------------------------------------

  if (!suggestion) {
    return (
      <div className="activity-page">
        <div className="activity-container activity-container--narrow">
          <div className="activity-message-card">
            <p className="activity-eyebrow">
              Progress Activity
            </p>

            <h1 className="activity-message-title">
              Activity Not Found
            </h1>

            <p className="activity-message-text">
              This activity does not exist or does not
              belong to this user.
            </p>

            <button
              onClick={() => navigate(-1)}
              className="activity-button activity-button--secondary"
            >
              Go Back
            </button>
          </div>
        </div>
      </div>
    );
  }

  // -----------------------------------------
  // Completed successfully
  // -----------------------------------------

  if (result) {
    return (
      <div className="activity-page activity-page--result">
        <div className="activity-container activity-container--narrow">

          <div className="activity-success-card">

            <div className="activity-success-content">

              <div className="activity-success-icon">
                ✓
              </div>

              <p className="activity-eyebrow activity-eyebrow--success">
                Progress Recorded
              </p>

              <h1 className="activity-success-title">
                Activity Completed!
              </h1>

              <p className="activity-success-text">
                Nice work. Your activity has been recorded.
              </p>

              <div className="activity-result-grid">

                <div className="activity-result-card">
                  <p className="activity-result-label">
                    Activity Score
                  </p>

                  <p className="activity-result-value">
                    {result.activityScore}
                  </p>
                </div>

                <div className="activity-result-card">
                  <p className="activity-result-label">
                    Category Score
                  </p>

                  <p className="activity-result-value">
                    {result.categoryScore}
                  </p>
                </div>

              </div>

              <p className="activity-category-result">
                Category:{" "}
                <span>
                  {result.category}
                </span>
              </p>

              <button
                onClick={() =>
                  navigate("/suggestions", {
                    state: {
                      userId,
                    },
                  })
                }
                className="activity-button activity-button--primary activity-button--full"
              >
                Back to Suggestions →
              </button>

            </div>
          </div>

        </div>
      </div>
    );
  }

  return (
    <div className="activity-page">

      <div className="activity-container activity-container--narrow">

        {/* Header */}

        <div className="activity-header">

          <button
            type="button"
            onClick={() => navigate(-1)}
            className="activity-back-button"
          >
            ← Back
          </button>

          <div className="activity-category-pill">
            {suggestion.category}
          </div>

          <h1 className="activity-title">
            {suggestion.activity}
          </h1>

          <p className="activity-reason">
            {suggestion.reason}
          </p>

        </div>

        {/* Activity information */}

        <div className="activity-info-grid">

          <div className="activity-info-card">
            <p className="activity-info-label">
              Category
            </p>

            <p className="activity-info-value">
              {suggestion.category}
            </p>
          </div>

          <div className="activity-info-card">
            <p className="activity-info-label">
              Scheduled
            </p>

            <p className="activity-info-value">
              {suggestion.scheduledTime}
            </p>
          </div>

          <div className="activity-info-card">
            <p className="activity-info-label">
              Target
            </p>

            <p className="activity-info-value">
              {suggestion.allocatedMinutes} minutes
            </p>
          </div>

        </div>

        {/* Form */}

        <form
          onSubmit={handleSubmit}
          className="activity-form"
        >

          {/* Activity */}

          <div className="activity-form-section">

            <label className="activity-form-label">
              Activity
            </label>

            <div className="activity-selected-card">

              <p className="activity-selected-name">
                {suggestion.activity}
              </p>

              {suggestion.kindOfActivity && (
                <p className="activity-kind">
                  {suggestion.kindOfActivity}
                </p>
              )}

            </div>

          </div>

          {/* Actual minutes */}

          <div className="activity-form-section">

            <label className="activity-form-label">
              How many minutes did you actually spend?
            </label>

            <input
              type="number"
              min="0"
              value={actualMinutes}
              onChange={(e) =>
                setActualMinutes(e.target.value)
              }
              placeholder={`Target: ${suggestion.allocatedMinutes} minutes`}
              required
              className="activity-input"
            />

          </div>

          {/* Rating */}

          <div className="activity-form-section">

            <label className="activity-form-label">
              How well did you do?
            </label>

            <div className="activity-rating-grid">

              {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map(
                (rating) => (
                  <button
                    key={rating}
                    type="button"
                    onClick={() => setSelfRating(rating)}
                    className={`activity-rating-button ${
                      selfRating === rating
                        ? "activity-rating-button--selected"
                        : ""
                    }`}
                  >
                    {rating}
                  </button>
                )
              )}

            </div>

            <p className="activity-rating-help">
              1 = very difficult · 10 = excellent
            </p>

          </div>

          {/* Notes */}

          <div className="activity-form-section">

            <label className="activity-form-label">
              Notes
            </label>

            <textarea
              value={notes}
              onChange={(e) =>
                setNotes(e.target.value)
              }
              rows={5}
              placeholder="How did it go? Anything you want to remember?"
              className="activity-input activity-textarea"
            />

          </div>

          {/* Error */}

          {error && (
            <div className="activity-error">
              {error}
            </div>
          )}

          {/* Submit */}

          <button
            type="submit"
            disabled={loading}
            className="activity-button activity-button--primary activity-button--full"
          >
            {loading
              ? "Completing Activity..."
              : "Complete Activity ✓"}
          </button>

        </form>

      </div>

    </div>
  );
}
